import { render, staticRenderFns } from "./redirigeWhatsApp.vue?vue&type=template&id=6041bdbb&"
import script from "./redirigeWhatsApp.vue?vue&type=script&lang=js&"
export * from "./redirigeWhatsApp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports